const ContactUsValidationRules = {
    email:'required|email',
    subject:'required',
    message:'required|max:500'
};

export default ContactUsValidationRules;